export default "__VITE_ASSET__BwqCx_Te__ 584w";